import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import formModalCSS from './formModal.module.css';

function FormModal({buttonTitle, modalTitle, body, openButtonClass, closeButtonClass}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
            <Button className={openButtonClass} variant="primary" onClick={handleShow}>
                {buttonTitle}
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={formModalCSS.body}>
                    {body}
                </Modal.Body>
                <Modal.Footer>
                <Button className={closeButtonClass} variant="primary" onClick={handleClose}>
                    Lukk
                </Button>
                </Modal.Footer>
            </Modal>
    </>
  );
}

export default FormModal;